import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetCallToAction } from "../queries/callToActions";
import { ENTITY } from "../constants";

export const CallToActionBreadcrumb = ({ match }) => {
    // Entity
    const { CALLTOACTION } = ENTITY;

  const {
    data: callToAction,
    isLoading,
    isError,
    error,
  } = useGetCallToAction(match.params.callToActionId);

  if (isLoading) {
    //return <span>Loading...</span>;
    return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
  }

  if (isError && error instanceof NotFoundException) {
    return <span>Not found</span>;
  }

  if (callToAction) {
    return <span>{trimString(callToAction[CALLTOACTION.nameField], 20)}</span>;
  }

  return null;
};
